import { mapState, mapActions } from 'vuex';
import { getPageName } from '../services/analytics/pageData';

export default {
    computed: {
        ...mapState('configuration', [
            'settings'
        ]),

        ...mapState('auth', [
            'authToken',
            'isAuthFinished'
        ])
    },

    async mounted () {
        try {
            // Don't keep wiring up auth for subsequent SPA navigations.
            if (!this.isAuthFinished) {
                await this.requestSilentRenew(this.settings);
            }
        } catch (error) {
            this.$log.warn(
                'Unable to request silent renew of auth token',
                'core-team',
                {
                    errorMessage: error.message
                }
            );
        } finally {
            this.$gtm.pushPageData({
                pageName: getPageName(this.$route, this.authToken)
            });

            this.$gtm.pushUserData({ authToken: this.authToken });
        }
    },

    methods: mapActions('auth', [
        'requestSilentRenew'
    ])
};
